module.exports = __webpack_public_path__ + "media/newstyle/images/word-file-icon-d0d60adad1d97dddb795991397ae3085.svg";